<!--
 * @Date: 2022-09-24 19:19:03
 * @LastEditTime: 2022-10-21 16:05:18
 * @Description: 青心计划 传播活动
-->
<template>
  <div class="qingxin-disseminate">
    <img
      src="https://resource.chunyu.mobi/@/media/images/2022/10/18/04f8/a0cfaf9db622_w1125_h7635_.jpg"
      alt=""
      class="bg"
    />
    <img
      src="https://resource.chunyu.mobi/@/media/images/2022/10/18/97b7/e59e5c86cf8c_w916_h153_.png"
      alt=""
      class="swiper-top-icon"
    />
    <div class="swiper">
      <swiper v-if="imgs.length" class="swiper-wrap" :options="swiperOption">
        <swiper-slide v-for="(img, index) in imgs" :key="index">
          <img class="icon" :src="img" @click="showImagePreview(img)"
        /></swiper-slide>
      </swiper>
    </div>
    <div
      v-show="
        showBttomBotton && ((!isFromChunyu && !isFromWeiXinMini) || !isLogin)
      "
      class="upload-button"
      @click="scrollToBottom"
    >
      晒超酷活力照
    </div>
    <UploadImg
      v-show="showBttomBotton && (isFromChunyu || isFromWeiXinMini) && isLogin"
      v-model="imageList"
      class="fixed-upload-btn"
      :visible.sync="isShowH5UploadLoading"
      :multiple="false"
      :upload-config="uploadConfig"
      origin="fixed-button"
    >
      <template>
        <div class="upload-button real-up">
          晒超酷活力照
        </div>
      </template>
    </UploadImg>
    <img
      v-if="!isLogin && (isFromChunyu || isFromWeiXinMini)"
      ref="bottomupload"
      class="unlogin up-img-button"
      src="https://resource.chunyu.mobi/@/media/images/2022/10/18/5c3d/0c1a33ac9212_w880_h883_.png"
      @click="login('up')"
    />
    <UploadImg
      v-if="isLogin && (isFromChunyu || isFromWeiXinMini)"
      v-model="imageList"
      class="bottom-upload-btn"
      :visible.sync="isShowH5UploadLoading"
      :multiple="false"
      :upload-config="uploadConfig"
      origin="bottom-button"
    >
      <template>
        <img
          ref="bottomupload"
          class="up-img-button"
          src="https://resource.chunyu.mobi/@/media/images/2022/10/18/5c3d/0c1a33ac9212_w880_h883_.png"
        />
      </template>
    </UploadImg>
    <img
      v-if="!isFromChunyu && !isFromWeiXinMini"
      ref="bottomupload"
      class="qrcode"
      src="https://resource.chunyu.mobi/@/media/images/2022/10/18/bd64/a20a4cf43e1d_w880_h883_.png"
    />
    <!-- 上传loading -->
    <Loading
      v-show="isShowH5UploadLoading"
      class="loading"
      :is-special="true"
      text="图片上传中..."
    />
  </div>
</template>

<script>
import { doPoint, requestEvent } from '@/utils/index';
import * as cyDetect from '@cy/detect';
import Loading from '@/components/Loading';
import cyShare from '@cy/share';
import { isLogin, getQinxinDisseminateHomeInfo } from '@/services/index';
import { wxSdkSign } from '@/utils/wx';
import UploadImg from './components/UploadImg';

const wx = require('weixin-js-sdk');

export default {
  components: {
    UploadImg,
    Loading,
  },
  data() {
    return {
      imgs: [],
      imageList: [
        'https://wx1.sinaimg.cn/mw1024/686d7361ly1fpha0mpd5uj21hc0tyws2.jpg',
      ],
      isShowH5UploadLoading: false, // 是否展示loading
      isFromChunyu: cyDetect.isFromCYAll(),
      isFromWeiXinMini: true,
      swiperOption: {
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,
        slidesPerView: 1.25, // 设置slider容器能够同时显示的slides数量,可以是小数,设置为2时,如图所示，设置为3则会出现三张完整的active slide
        spaceBetween: -20,
        centeredSlides: true, // 设定为true时，active slide会居中，而不是默认状态下的居左
        loop: true,
        slideToClickedSlide: true, // true:点击slide会过渡到这个slide,默认false
        pagination: {
          el: '.swiper-pagination',
        },
      },
      isLogin: false,
      showBttomBotton: true, // 展示吸底按钮
      uploadConfig: {
        // 上传配置
        validateOptions: {
          miniCount: 1,
          maxCount: 2, // 上传数量
          miniSize: '0',
          maxSize: '10240', // 文件大小
          typesCanBeSent: [
            'image/gif',
            'image/png',
            'image/jpeg',
            'image/bmp',
            'image/webp',
          ], // 文件类型
        },
      },
    };
  },
  watch: {
    imageList(n) {
      if (n.length) {
        window.sessionStorage.setItem('img', n[0]);
        window.location.href = `/v-m-general/caring-elder/bill`;
      }
    },
  },
  mounted() {
    this.fromJudge();
    this.handleShare();
    this.getData();
    wxSdkSign();
    isLogin().then(res => {
      const { is_login } = res;
      if (is_login) {
        this.isLogin = true;
      }
      this.$nextTick(() => {
        const io = new IntersectionObserver(this.entryView);
        console.log(this.$refs.bottomupload, 'da');
        io.observe(this.$refs.bottomupload);
      });
    });
    this.doPagePoint('PageView', {
      activity_name: '海报传播活动',
      page_title: document.title,
    });
  },
  methods: {
    /**
     * 获取数据
     */
    getData() {
      getQinxinDisseminateHomeInfo({
        alias: 'idop',
      }).then(resp => {
        console.log(resp, 'resp');
        this.imgs = resp.image_list;
      });
    },
    /**
     * 上传进入视口
     *
     * @param resp
     */
    entryView(resp) {
      console.log(resp, 'entey');
      const IntersectionObserverEntry = resp[0];
      if (IntersectionObserverEntry.isIntersecting) {
        this.showBttomBotton = false;
      } else {
        this.showBttomBotton = true;
      }
    },
    /**
     * 登录
     *
     * @param tag
     */
    login(tag) {
      if (tag) {
        this.doPagePoint('AppClick', {
          activity_name: '海报传播活动',
          page_title: document.title,
          click_position: '上传图片-页面底部',
        });
      }
      requestEvent();
    },
    /**
     * 滚动到页面最底端
     */
    scrollToBottom() {
      if (!this.isLogin) {
        this.login();
        return;
      }
      window.scroll(0, document.querySelector('body').scrollHeight);
    },
    /**
     * 环境判断
     */
    fromJudge() {
      wx.miniProgram.getEnv(wxres => {
        if (wxres.miniprogram) {
          // 小程序环境
          this.isFromWeiXinMini = true;
        }
      });
    },
    /**
     * 打点函数
     *
     * @param type type
     * @param data 打点数据
     */
    doPagePoint(type, data) {
      let app;
      if (cyDetect.isFromCY()) {
        app = '0';
      } else if (cyDetect.isFromCYClinic()) {
        app = '1';
        // eslint-disable-next-line no-underscore-dangle
      } else if (window.__wxjs_environment === 'miniprogram') {
        app = 'weixin_mini';
      }
      return doPoint(type, {
        app,
        ...data,
      });
    },
    /**
     * 图片预览
     *
     * @param image 图片
     */
    showImagePreview(image) {
      this.$createImagePreview({
        imgs: [image],
        // initialIndex: index,
      }).show();
    },
    /**
     * 分享
     */
    handleShare() {
      const opt = {
        title: '银发生活欢快多！晒照片，赢锦鲤好礼',
        mini_image:
          'https://resource.chunyu.mobi/@/media/images/2022/10/19/94ca/08bef4baaa4e_w1075_h1075_.png',
        img:
          'https://resource.chunyu.mobi/@/media/images/2022/10/19/94ca/08bef4baaa4e_w1075_h1075_.png',
        // btn_visible: false,
        share_to: ['weixin_haoyou', 'weixin_pengyouquan', 'qq', 'weibo'],
        userName: 'gh_681d3fd5683f', // 安卓
        mini_id: 'gh_681d3fd5683f', // IOS
        path: `/pages/h5_webview/index?url=${encodeURIComponent(
          window.location.href
        )}`,
      };
      cyShare.app(opt);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.qingxin-disseminate {
  position: relative;
  .bg {
    width: 100vw;
    object-fit: contain;
  }
  .swiper-top-icon {
    position: absolute;
    top: rem(459);
    left: 50%;
    width: rem(305);
    transform: translateX(-50%);
  }
  .upload-button {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    width: 100vw;
    height: rem(60);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    line-height: rem(60);
    text-align: center;
    background: #ff9212;
  }
  .fixed-upload-btn {
    position: fixed;
    bottom: 0;
    z-index: 1000;
    width: 100vw;
    height: rem(60);
    color: #fff;
    font-weight: bold;
    font-size: rem(16);
    line-height: rem(60);
    text-align: center;
    background: #ff8400;
  }
}
.swiper-container {
  padding-bottom: rem(13);
}
.swiper-slide {
  transform: scale(0.8);
  // transition: 0.1s;
}
.icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}
//swriper自带的类名（选中时的样式）
.swiper-slide-active {
  transform: scale(1);
}
.swiper-pagination {
  bottom: rem(0);
  left: 50%;
  transform: translateX(-50%);
}
::v-deep .swiper-pagination-bullet {
  width: rem(5);
  height: rem(5);
  margin-right: rem(3);
  background: #e4e4e4;
  border-radius: 50%;
  &.swiper-pagination-bullet-active {
    width: rem(9);
    background: #16759c;
    border-radius: 3px;
  }
}
.swiper-wrap {
  position: absolute;
  top: 14.6rem;
  left: rem(30);
  width: 86vw;
  height: rem(161);
  overflow: hidden;
  transform: translate3d(0, 0, 0);
}
.up-img-button {
  width: rem(294);
}
.bottom-upload-btn {
  bottom: 3.693333rem;
  left: 50%;
  width: 7.84rem;
  height: 7.84rem;
  transform: translateX(-50%);
}
.unlogin {
  position: absolute;
  bottom: 3.693333rem;
  left: 50%;
  width: 7.84rem;
  height: 7.84rem;
  transform: translateX(-50%);
}
.qrcode {
  position: absolute;
  bottom: 3.693333rem;
  left: 50%;
  width: rem(294);
  transform: translateX(-50%);
}
.real-up {
  left: 0;
  z-index: 0 !important;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 1000;
  transform: translate(-50%, -50%);
}
</style>
